import { red } from "@mui/material/colors"
import { createTheme } from "@mui/material/styles"

const theme = createTheme({
  palette: {
    primary: {
      // main: "#98e39c",
      main: "#4D91D0",
    },
    secondary: {
      // main: "#206e24",
      // main: "#02223C",
      main: "#033863",
    },
    hover: {
      main: "#EBF6FE",
    },
    bmprimary: {
      main: "#7395fa",
    },
    bmsecondary: {
      main: "#142969",
    },
    start: {
      main: "#98e39c",
      hover: "#206e24",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#FFFFFF",
    },
  },
})

export default theme
